import { createRouter, createWebHistory } from 'vue-router';
import Home from '@/views/Home.vue';
import About from '@/views/About.vue';
import Dashboard from '@/components/Dashboard.vue';
import store from '@/store';

const routes = [
  {
    name: 'home', // allow to assign name to the route record
    path: '/', // URL part after the domain
    component: Home, // value = render contents of this component
  },
  {
    name: 'about',
    path: '/about',
    component: About,
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
  },
  {
    // catch-all routes - checked last
    path: '/:catchAll(.*)*',
    // regEx value
    // * char = cathc a path that doesn't exist within the records
    redirect: { name: 'home' },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkExactActiveClass: 'text-yellow-500',
});

router.beforeEach((to, from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) {
    // record param = current item in the iteration
    next();
    return;
  }

  if (store.state.userLoggedIn) {
    next();
  } else {
    next({ name: 'home' });
  }
});

export default router;
